import { OrderStatus } from '@yandex-taxi/js-integration-api';
export var isCancelableStatus = function (status) { return [
    OrderStatus.CANCELLED,
    OrderStatus.EXPIRED,
    OrderStatus.FAILED,
].indexOf(status) < 0; };
